import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'cupons',
		name: 'Cupons de Desconto',
		components: {
			default: () =>
				import('@/views/application/configuracaoDeCupom/TelaDeCupons.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'cupons' as TipoDeRecurso,
		},
	},
]

export default rotas